/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerdetailsdescription2Inputs */

const en_organizerdetailsdescription2 = /** @type {(inputs: Organizerdetailsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For organisers, clubs and companies. Everyone sees the name, text and links on your profile.`)
};

const de_organizerdetailsdescription2 = /** @type {(inputs: Organizerdetailsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Veranstalter, Vereine und Firmen. Name, Text und Links sehen alle auf deinem Profil.`)
};

/**
* | output |
* | --- |
* | "For organisers, clubs and companies. Everyone sees the name, text and links on your profile." |
*
* @param {Organizerdetailsdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerdetailsdescription2 = /** @type {((inputs?: Organizerdetailsdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerdetailsdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerdetailsdescription2(inputs)
	return de_organizerdetailsdescription2(inputs)
});
export { organizerdetailsdescription2 as "organizerDetailsDescription" }